import React, { useState, useRef } from "react";
import { useEffect } from "react";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
} from "react-leaflet";
import location from "../../../images/location.png";
import sedan from "../../../images/SEDAN.png";
import hatchBack from "../../../images/HATCHBACK.png";
import suv from "../../../images/SUV.png";
import swal from "sweetalert";
import { Spinner, Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import styles from "../OrderListAll/orderListAll.module.css";
import globalStyles from "../OrderListAll/index.module.css";
import { Box, Divider} from "@mui/material";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { LatLng, LatLngBounds } from "leaflet";
import {
  DeliLocateText,
  AddressFullText,
  OrderIdText,
  OrderStatusFareText,
  PackPriceText,
} from "../OrderListAll/AllStyledComponents";
import io from "socket.io-client";
const ReadMore = ({ children }) => (
  <>
    {children?.length != 0 ? children.slice(0, 75) : children}
    {children?.length >= 75 ? <b>...</b> : null}
  </>
);
var socket = io.connect(`${Baseurl.baseurl}`, {
  transports: ["websocket"],

});
export default function AssignedRidesRentals() {
  const mapRef = useRef(null);
  const mapRef2 = useRef(null);
  const [orderList, setOrderList] = useState(null);
  const [orderlist, setOrderslist] = useState([]);
  const [rider, setRider] = useState("");
  const history = useHistory();
  const containerRef = useRef(null);
  const [orderData, setOrderData] = useState([]);
  const [riderData, setRiderData] = useState([]);
  const [searchRiderData, setSearchRiderData] = useState([]);
  const [name, setName] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [customerLoc, setCustomerLoc] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [orderId, setOrderId] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [customer, setCustomer] = useState("");
  const [polyChords, setPolyChords] = useState([]);
  const [bounds, setBounds] = useState([]);
  const [boundaries, setBoundaries] = useState([]);
  var L = window.L;
  var myIcon = L.icon({
    iconUrl: location,
    iconSize: [20, 35],
  });
  var customerPng = L.icon({
    iconUrl: customer,
    iconSize: [50, 60],
  });
  var sedanPng = L.icon({
    iconUrl: sedan,
    iconSize: [50, 60],
  });
  var hatchBackPng = L.icon({
    iconUrl: hatchBack,
    iconSize: [50, 60],
  });
  var suvPng = L.icon({
    iconUrl: suv,
    iconSize: [50, 60],
  });
  function getAllRiders(vehicle) {
    axios
      .get(`${Baseurl.baseurl}/go-rentals/get-all-available-rental-riders`)
      .then((res) => {
        let vikki = [];
        if (res.data.status) {
          res.data.details.map((val) => {
            if (val.RiderVehicleType.name === vehicle) {
              vikki.push(val);
            }
          });
          let newBounds = vikki.map(
            (coords) => new LatLng(coords.RiderCurrentLat_Lng.lat, coords.RiderCurrentLat_Lng.lng)
          );
          setBoundaries(newBounds);
          if (mapRef2.current && newBounds.length > 0) {
            const leafletMap = mapRef2.current;
      
            const leafletBounds = new LatLngBounds(newBounds);
            leafletMap.setView(
              leafletBounds.getCenter(),
              leafletMap.getBoundsZoom(leafletBounds)
            );
          }
          setRiderData(vikki);
          setSearchRiderData(vikki)
        }
      })
      .catch((err) => {});
  }
  function getAllOrders() {
    setSpinner(true);
    axios
      .get(`${Baseurl.baseurl}/go-rentals/get-all-assigned-rental-riders`)
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setOrderData(res.data.details);
        } else {
          setOrderData([]);
        }
      })
      .catch((err) => {});
  }
  useEffect(() => {
    getAllOrders();
  }, []);
  const handleScroll = () => {
    const container = containerRef.current;
    const scrollEnd = container.scrollHeight - container.offsetHeight;
    if (parseInt(container.scrollTop) === scrollEnd - 1) {
     // getAllOrders();
    }
  };
  function assignRider(val, id) {
    let details = {
      orderId: orderId,
      riderName: name,
      riderPhone: phoneNumber,
      riderVehicleNumber: vehicleNumber,
      otherRider: val,
      riderId: val ? "" : id,
    };
    axios
      .put(
        `${Baseurl.baseurl}/go-rentals/reassign-rental-schedule-rider`,
        details
      )
      .then((response) => {
        if (response.data.status) {
          swal("Re-Assigned", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getAllOrders();
          setOrderId("");
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getOrderDetails(orderId) {
    axios
      .get(`${Baseurl.baseurl}/go-porter/get-porter-order-by-id/${orderId}`)
      .then((response) => {
        setOrderList(response?.data);
        setOrderslist(response.data.porterOrder);
        let vikki = [];
        if (response.data.porterOrder.DirectionLatLng.length !== 0) {
          response.data.porterOrder.DirectionLatLng.map((val) => {
            vikki.push([val.lat, val.lng]);
          });
        }
        setPolyChords(vikki);
        if (response?.data?.porterOrder?.OrderStatus == "Completed") {
        } else {
        }
        axios
          .get(
            `${Baseurl.baseurl}/user/get-user-by-id/${response.data.porterOrder.Customer}`
          )
          .then((resRider) => {
            console.log("fffmff", resRider);
            if (resRider.data.status) {
              setCustomer(resRider.data.user);
            }
          })
          .catch((err) => {
            if (err.toString() === "Error: Network Error") {
              history.push("/offline");
            } else {
              history.push("/400");
            }
          });
        axios
          .get(
            Baseurl.baseurl +
              `/rider/get-rider-by-id/${response.data.porterOrder.OrderDeliveryBoy}`
          )
          .then((result) => {
            setRider(result.data.data);
          });
        setSpinner(false);
      })
      .catch((error) => {});
  }

  useEffect(() => {
    const newBounds = polyChords.map(
      (coords) => new LatLng(coords[0], coords[1])
    );
    setBounds(newBounds);
    if (mapRef.current && newBounds.length > 0) {
      const leafletMap = mapRef.current;

      const leafletBounds = new LatLngBounds(bounds);
      leafletMap.setView(
        leafletBounds.getCenter(),
        leafletMap.getBoundsZoom(leafletBounds)
      );
    }
  }, [polyChords]);

  useEffect(() => {
    socket.on(`${orderId}`, (data) => {
      getAllOrders();
    });
  }, []);
  function searchRiderByPhoneNumber(phoneNumber){
    let rider=[]
      if(searchRiderData.length!==0){
        searchRiderData.map((val)=>{
          
          if(val.riderPhone.toString().includes(phoneNumber)){
            rider.push(val)
          }
        })
        let newBounds = rider.map(
          (coords) => new LatLng(coords.RiderCurrentLat_Lng.lat, coords.RiderCurrentLat_Lng.lng)
        );
        setBoundaries(newBounds);
        if (mapRef2.current && newBounds.length > 0) {
          const leafletMap = mapRef2.current;
    
          const leafletBounds = new LatLngBounds(newBounds);
          leafletMap.setView(
            leafletBounds.getCenter(),
            leafletMap.getBoundsZoom(leafletBounds)
          );
        }
        setRiderData(rider)
      }
  }
  return (
    <div className="row">
      <div className="col-sm-4">
        {spinner ? (
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div
            className="cat_block text-center"
            style={{ overflowY: "auto", height: window.innerHeight / 1.3 }}
            ref={containerRef}
            onScroll={handleScroll}
          >
            <div className="category_list">
              {orderData.length !== 0 ? (
                <>
                  {orderData &&
                    orderData.map((val, index) => {
                      return (
                        <ul
                          onClick={() => {
                            setCustomerLoc({
                              lat: val.OrderId.Address[0].Lat,
                              lng: val.OrderId.Address[0].Lon,
                            });
                            getAllRiders(val.OrderId.VehicleType);
                            getOrderDetails(val.OrderId._id);
                            setOrderId(val.OrderId._id);
                            setOrderStatus(val.OrderId.OrderStatus)
                          }}
                        >
                          <li
                            style={{
                              cursor: "pointer",
                              width: "230px",
                              textAlign: "center",
                              padding: "5px",
                              borderRadius: "8px",
                              backgroundColor: "#F0F0F0",
                              border:
                                orderId &&
                                orderId === val.OrderId._id &&
                                "solid 1.5px #135334",
                            }}
                          >
                            <text
                              className="float-left"
                              style={{
                                color: "black",
                                fontWeight: "600",
                                fontFamily: "sans-serif",
                                padding: "5px",
                                fontSize: "14px",
                              }}
                            >
                              Order {index + 1}
                            </text>
                            <text
                              className="float-right"
                              style={{
                                color: "orange",
                                fontWeight: "600",
                                fontFamily: "sans-serif",
                                padding: "5px",
                                fontSize: "15px",
                              }}
                            >
                              {val.OrderId.OrderStatus.toString().toUpperCase()}
                            </text>
                            <hr
                              className="bg-light"
                              style={{ marginTop: "35px" }}
                            ></hr>

                            <text
                              className="float-left"
                              style={{
                                color: "red",

                                fontFamily: "sans-serif",
                                padding: "5px",
                                fontSize: "14px",
                                borderRadius: "5px",
                                width: "120px",
                              }}
                            >
                              {" "}
                              {val.OrderId.VehicleType}
                            </text>

                            <text
                              className="float-right"
                              style={{
                                color: "black",
                                fontWeight: "600",
                                fontFamily: "sans-serif",
                                padding: "5px",
                                fontSize: "15px",
                                backgroundColor: "white",
                                borderRadius: "5px",
                                width: "60px",
                              }}
                            >
                              {val.OrderId.Code}
                            </text>
                            <text
                              className="float-left"
                              style={{
                                color: "black",

                                fontFamily: "sans-serif",
                                padding: "5px",
                                fontSize: "12px",
                                marginTop: "8px",
                              }}
                            >
                              {val.Hour === 0
                                ? 12
                                : val.Hour === 12
                                ? val.Hour
                                : val.Hour > 12
                                ? val.Hour - 12
                                : val.Hour}
                              :{val.Minute}{" "}
                              {val.Hour === 0
                                ? "AM"
                                : val.Hour === 12
                                ? "PM"
                                : val.Hour > 12
                                ? "PM"
                                : "AM"}
                            </text>
                            <text
                              className="float-right"
                              style={{
                                color: "black",

                                fontFamily: "sans-serif",
                                padding: "5px",
                                fontSize: "12px",
                                marginTop: "6px",
                              }}
                            >
                              {val.Day}-{val.Month}-{val.Year}
                            </text>
                          </li>
                        </ul>
                      );
                    })}
                </>
              ) : (
                <div
                  className="text-center"
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    height: "150px",
                    marginTop: "150px",
                  }}
                >
                  No Orders Found{" "}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div
        className="col-sm-8"
        style={{ overflowY: "auto", height: window.innerHeight / 1.3,width:'100%',overflowX:'hidden' }}
      >
       
        {orderStatus!=='Completed'&&orderData.length !== 0&&orderId&&riderData.length!==0&&(
          <>
           <div className="col-sm-6 mb-3">
           <input
                       onWheel={(e) => e.target.blur()}
                       type="number"
                       className="form-control"
                       placeholder="seacrh rider by Phone Number"
                       onChange={(e) => searchRiderByPhoneNumber(e.target.value)}
                     />
           </div>
           <MapContainer
           ref={mapRef2}
           style={{
             height: window.innerHeight / 1.9,
             width: window.innerWidth / 2,
           }}
          //  center={[12.914125, 77.642114]}
          //  zoom={10}
           scrollWheelZoom={true}
           bounds={boundaries}
           boundsOptions={boundaries}
         >
           {/* <TileLayer
               attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
               url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
             /> */}
           <TileLayer
             url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
             maxZoom={21}
             minZoom={4}
             minZoomIsDrawing={18}
             subdomains={["mt0", "mt1", "mt2", "mt3"]}
           />
           {customerLoc && (
             <Marker icon={myIcon} position={[customerLoc.lat, customerLoc.lng]}>
               <Popup>Customer</Popup>
             </Marker>
           )}
 
           {riderData.length!==0 &&
             riderData.map((val) => {
               return (
                 <>
                   {val.RiderVehicleType.name === "Sedan" && (
                     <Marker
                       icon={sedanPng}
                       position={[
                         val.RiderCurrentLat_Lng.lat,
                         val.RiderCurrentLat_Lng.lng,
                       ]}
                     >
                       <Popup>
                         {val.riderFirstName} {val.riderLastName}
                         <br />
                         {val.RiderVehicleType.name}
                         <br />
                         <div className="text-center">
                           <button
                             onClick={() => {
                               assignRider(false, val._id);
                             }}
                             className="btn btn-primary p-1 mt-2"
                             style={{ borderRadius: "8px", fontSize: "12px" }}
                           >
                             Re-Assign
                           </button>
                         </div>
                       </Popup>
                     </Marker>
                   )}
                   {val.RiderVehicleType.name === "SUV/MUV" && (
                     <Marker
                       icon={suvPng}
                       position={[
                         val.RiderCurrentLat_Lng.lat,
                         val.RiderCurrentLat_Lng.lng,
                       ]}
                     >
                       <Popup>
                         {val.riderFirstName} {val.riderLastName}
                         <br />
                         {val.RiderVehicleType.name}
                         <br />
                         <div className="text-center">
                           <button
                             onClick={() => {
                               assignRider(false, val._id);
                             }}
                             className="btn btn-primary p-1 mt-2"
                             style={{ borderRadius: "8px", fontSize: "12px" }}
                           >
                             Re-Assign
                           </button>
                         </div>
                       </Popup>
                     </Marker>
                   )}
                   {val.RiderVehicleType.name === "Hatch Back" && (
                     <Marker
                       icon={hatchBackPng}
                       position={[
                         val.RiderCurrentLat_Lng.lat,
                         val.RiderCurrentLat_Lng.lng,
                       ]}
                     >
                       <Popup>
                         {val.riderFirstName} {val.riderLastName}
                         <br />
                         {val.RiderVehicleType.name}
                         <br />
                         <div className="text-center">
                           <button
                             onClick={() => {
                               assignRider(false, val._id);
                             }}
                             className="btn btn-primary p-1 mt-2"
                             style={{ borderRadius: "8px", fontSize: "12px" }}
                           >
                             Re-Assign
                           </button>
                         </div>
                       </Popup>
                     </Marker>
                   )}
                 </>
               );
             })}
         </MapContainer>
          </>
        )}
       

        { orderData.length !== 0 && orderId && (
          <>
          {orderStatus!=='Completed'&&(
           <>
            {riderData.length===0&&(
             <div
             className="text-center"
             style={{
               color: "red",
               fontSize: "16px",
               fontWeight: "600",
               marginTop:'6px'
             }}
           >
             
             No Rider Present to Re-Assign
           </div>
          )}
            <div
              className="row mt-3"
              style={{
                fontSize: "14px",
              }}
            >
              <div className="col-sm-3">
                <label>Name</label>
                <div className="mb-2">
                  <input
                    onWheel={(e) => e.target.blur()}
                    type="text"
                    className="form-control"
                    placeholder="enter name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <label>Phone Number</label>
                <div className="input-group mb-2">
                  <input
                    onWheel={(e) => e.target.blur()}
                    type="text"
                    className="form-control"
                    placeholder="enter number"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <label>Vehicle Number</label>
                <div className="input-group mb-2">
                  <input
                    onWheel={(e) => e.target.blur()}
                    type="text"
                    className="form-control"
                    placeholder="vehicle number"
                    value={vehicleNumber}
                    onChange={(e) => setVehicleNumber(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-3 mt-1">
                <button
                  className="btn btn-primary mt-4"
                  onClick={() => {
                    assignRider(true);
                  }}
                >
                  Re-Assign
                </button>
              </div>
            </div>
            <hr></hr>
           </>
          )}
          
           
            <div className="text-center mb-3 text-primary" style={{fontSize:'18px',fontWeight:'600'}}>Order Details</div>
            <div className="h-80">
              <div className="row">
                <div className="col-xl-12 col-xxl-12 m-0">
                  <div className="card p-0 m-0" style={{}}>
                    <div className="card-body p-0 ">
                      <div
                        className={`${styles.order_list_isbdfyavy} ${globalStyles.margin_bottom_xxl}`}
                      >
                        {orderList?.status && (
                          <>
                            <div className={styles.orderlist_main_block}>
                              <Box className={styles.order_section_box_block}>
                                <DeliLocateText>
                                  {orderList?.porterOrder.Hour > 12
                                    ? orderList?.porterOrder.Hour - 12
                                    : orderList?.porterOrder.Hour}
                                  :{orderList?.porterOrder.Minute}
                                  {orderList?.porterOrder.Hour > 12
                                    ? " PM"
                                    : " AM"}
                                  &nbsp;
                                  {" " + orderList?.porterOrder.Date},
                                  {" " +
                                    orderList?.porterOrder.Month.slice(0, 3)}
                                  ,{" " + orderList?.porterOrder.Year}
                                </DeliLocateText>
                              </Box>
                              <Box className={styles.order_section_box_block}>
                                <DeliLocateText
                                  className={styles.vertical_gap_xsmall}
                                >
                                  Order Type
                                </DeliLocateText>
                                <OrderIdText
                                  className={styles.vertical_gap_small}
                                >
                                  {orderList?.porterOrder.OrderType.replace(
                                    "_",
                                    " "
                                  )}
                                </OrderIdText>
                                <Divider className={styles.vertical_gap_big} />
                              </Box>
                              <Box className={styles.order_section_box_block}>
                                <>
                                  <Box
                                    className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                  >
                                    <DeliLocateText>
                                      Order Status
                                    </DeliLocateText>
                                    <DeliLocateText>Amount</DeliLocateText>
                                  </Box>
                                  <Box
                                    className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                  >
                                    <OrderStatusFareText>
                                      {orderList?.porterOrder?.OrderStatus}
                                    </OrderStatusFareText>
                                    <OrderStatusFareText>
                                      ₹ {orderList?.porterOrder?.Amount}
                                    </OrderStatusFareText>
                                  </Box>
                                  <Divider
                                    className={styles.vertical_gap_big}
                                  />
                                  {orderList?.porterOrder?.OrderStatus ===
                                  "Schedule" ? (
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box
                                          className={`${styles.order_section_box_block} ${styles.vertical_gap_big}`}
                                        >
                                          <DeliLocateText>
                                            Scheduled time{" "}
                                          </DeliLocateText>
                                          <OrderStatusFareText
                                            className={
                                              styles.vertical_gap_small
                                            }
                                          >
                                            {orderList?.porterOrder.Hour > 12
                                              ? orderList?.porterOrder.Hour - 12
                                              : orderList?.porterOrder.Hour < 10
                                              ? "0" +
                                                orderList?.porterOrder.Hour
                                              : orderList?.porterOrder.Hour}
                                            :
                                            {orderList?.porterOrder.Minute < 10
                                              ? "0" +
                                                orderList?.porterOrder.Minute
                                              : orderList?.porterOrder.Minute}
                                            {orderList?.porterOrder.Hour > 12
                                              ? " PM"
                                              : " AM"}
                                            &nbsp;
                                            {" " + orderList?.porterOrder.Date},
                                            <span
                                              className={
                                                globalStyles.text_transform_capitalize
                                              }
                                            >
                                              {" " +
                                                orderList?.porterOrder.Month.slice(
                                                  0,
                                                  3
                                                )}
                                            </span>
                                            ,{" " + orderList?.porterOrder.Year}
                                          </OrderStatusFareText>
                                        </Box>
                                      </div>
                                      <Divider
                                        className={styles.vertical_gap_big}
                                      />
                                    </>
                                  ) : null}
                                  <Box
                                    className={`${styles.order_section_box_block} ${styles.vertical_gap_big}`}
                                  >
                                    <DeliLocateText>
                                      Vehicle Type{" "}
                                    </DeliLocateText>
                                    <OrderStatusFareText
                                      className={styles.vertical_gap_small}
                                    >
                                      {orderList?.porterOrder?.VehicleType}
                                    </OrderStatusFareText>
                                  </Box>

                                  <Divider
                                    className={styles.vertical_gap_big}
                                  />
                                  <DeliLocateText
                                    className={styles.vertical_gap_big}
                                  >
                                    Trip details
                                  </DeliLocateText>
                                  <Box
                                    className={`${styles.vertical_gap_medium} ${styles.address_flex_block} `}
                                  >
                                    <Box
                                      className={styles.padding_top_sevnndsub}
                                    >
                                      <MyLocationIcon
                                        className={
                                          styles.font_size_eighteenfdfd
                                        }
                                      />
                                      <div
                                        className={`${globalStyles.display_flex_justify_center_blk} ${styles.loaction_iconjhweudfubeu}`}
                                      >
                                        <div
                                          className={styles.dash_blk_hdhsfaf}
                                        />
                                      </div>
                                      <LocationOnIcon
                                        className={
                                          styles.font_size_eighteenfdfd
                                        }
                                      />
                                    </Box>
                                    &nbsp;&nbsp;
                                    <Box>
                                      <Box>
                                        <PackPriceText>From</PackPriceText>
                                        <AddressFullText
                                          className={` ${styles.vertical_gap_xsmall} ${styles.address_text_color} ${styles.address_font_size} ${styles.fixed_hight_address_block}`}
                                        >
                                          <ReadMore>
                                            {
                                              orderList?.porterOrder?.Address[0]
                                                .Address
                                            }
                                          </ReadMore>
                                        </AddressFullText>
                                      </Box>
                                      <Divider
                                        className={styles.vertical_gap_medium}
                                      />
                                      <Box
                                        className={styles.vertical_gap_medium}
                                      >
                                        <PackPriceText>To</PackPriceText>
                                        <AddressFullText
                                          className={` ${styles.vertical_gap_xsmall} ${styles.address_text_color} ${styles.address_font_size} ${styles.fixed_hight_address_block}`}
                                        >
                                          {/* <ReadMore>
                                            {
                                              orderList?.porterOrder?.Address[1]
                                                .Address
                                            }
                                          </ReadMore> */}
                                        </AddressFullText>
                                      </Box>
                                    </Box>
                                  </Box>
                                  <Divider
                                    className={styles.vertical_gap_big}
                                  />
                                  <DeliLocateText
                                    className={styles.vertical_gap_big}
                                  >
                                    Billing Details
                                  </DeliLocateText>
                                  <Box
                                    className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                  >
                                    <AddressFullText>
                                      Ride Charge
                                    </AddressFullText>
                                    <AddressFullText
                                      className={styles.address_text_color}
                                    >
                                      ₹{" "}
                                      {
                                        orderList?.porterOrder?.RiderPrice
                                          ?.RideFare
                                      }
                                    </AddressFullText>
                                  </Box>
                                  <Box
                                    className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                  >
                                    <AddressFullText>
                                      Booking Fee & Convince fee
                                    </AddressFullText>
                                    <AddressFullText
                                      className={styles.address_text_color}
                                    >
                                      ₹ 0
                                    </AddressFullText>
                                  </Box>
                                  <Box
                                    className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                  >
                                    <AddressFullText>
                                      Platform charges
                                    </AddressFullText>
                                    <AddressFullText
                                      className={styles.address_text_color}
                                    >
                                      ₹{" "}
                                      {orderList?.porterOrder?.Amount -
                                        orderList?.porterOrder?.RiderPrice
                                          ?.RideFare}
                                    </AddressFullText>
                                  </Box>
                                  <Box
                                    className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium} ${styles.order_flex_profile_block}`}
                                  >
                                    <Box>
                                      <PackPriceText>Total </PackPriceText>
                                      <OrderIdText>
                                        Inclusive of Taxes
                                      </OrderIdText>
                                    </Box>
                                    <PackPriceText
                                      className={styles.address_text_color}
                                    >
                                      ₹ {orderList?.porterOrder?.Amount}
                                    </PackPriceText>
                                  </Box>
                                  <Divider
                                    className={styles.vertical_gap_big}
                                  />
                                </>
                              </Box>
                            </div>
                          </>
                        )}

                        <style>
                          {`
                    #activeSelected{
                        background-color: #0A92B2 !important;
                        color: #FFFFFF !important;
                    }


                    .css-1h8fkga {
                        min-height: 192px !important;
                    }
                    .css-1t1j96h-MuiPaper-root-MuiDialog-paper{
                        border-radius:10px !important;
                    }
                    .css-1u3bzj6-MuiFormControl-root-MuiTextField-root{
                      width:100% !important;
                      height: 100% !important;
                    }
                    .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root{
                      width:100% !important;
                      height: 100%!important;
                    }
                   
                    .css-hlj6pa-MuiDialogActions-root:fist-child {
                      background-color:red !important;
                    }
                    .css-hlj6pa-MuiDialogActions-root{
                      position: relative !important;
                    }

                    .darkBG {
                        background-color: rgba(0, 0, 0, 0.2);
                        width: 100vw;
                        height: 100vh;
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 3;
                        }
                        
                        .centered {
                            position: fixed;
                            bottom: 0px;
                            right: 0px;
                            z-index:5;
                            width:100%;
                            height:80%;
                        }
                        
                        .modal {
                            width: 100%;
                            height: 100%;
                            background: white;
                            color: white;
                            z-index: 5;
                            border-radius: 10px 10px 0px 0px;
                            box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
                            margin-top:20px;
                        }
                        #overflowYAxisScrll{
                            overflowY:scroll !important;
                        }
                        
                        #overflowYAxisnotScrll{
                            overflowY:none !important;
                        }
        

                    `}
                        </style>
                      </div>
                      <Table id="myTable" responsive>
                        <tbody>
                          <tr>
                            <td>
                              <div className="col-sm-12 ">
                                <h5 className=" text-sm">OrderID:</h5>
                              </div>
                            </td>
                            <td>
                              <h5 className=" text-sm">{orderlist._id}</h5>
                            </td>
                          </tr>

                          {orderlist.Address &&
                            orderlist.Address.map((val) => {
                              if (val.Origin) {
                                return (
                                  <tr>
                                    <td>
                                      <div className="col-sm-12">
                                        <h5 className=" text-sm">
                                          Pickup address:
                                        </h5>
                                      </div>
                                    </td>
                                    <td>
                                      <h5 className=" text-sm">
                                        Code:{val.Code}
                                        <br /> Name: {val.Name} <br />
                                        Contact: {val.Contact}
                                        <br /> Address: {val.Address}
                                      </h5>
                                      {val.Photo &&
                                        val.Photo.map((item) => {
                                          return (
                                            <div
                                              style={{
                                                marginTop: "5px",
                                                width: 180,
                                                height: 100,
                                                aspectRatio: 1 * 1.4,
                                              }}
                                              className="col-sm-8"
                                            >
                                              <img
                                                alt=""
                                                style={{
                                                  resizeMode: "cover",
                                                  width: "100%",
                                                  height: "100%",
                                                }}
                                                className="playerProfilePic_home_tile"
                                                src={item}
                                              />
                                            </div>
                                          );
                                        })}
                                    </td>
                                  </tr>
                                );
                              } else {
                                return (
                                  <tr>
                                    <td>
                                      <div className="col-sm-12">
                                        <h5 className=" text-sm">
                                          Drop address:
                                        </h5>
                                      </div>
                                    </td>
                                    <td>
                                      <h5 className=" text-sm">
                                        Code:{val.Code}
                                        <br /> Name: {val.Name} <br />
                                        Contact: {val.Contact}
                                        <br /> Address: {val.Address}
                                      </h5>
                                      {val.Photo &&
                                        val.Photo.map((item) => {
                                          return (
                                            <div
                                              style={{
                                                marginTop: "5px",
                                                width: 180,
                                                height: 100,
                                                aspectRatio: 1 * 1.4,
                                              }}
                                              className="col-sm-8"
                                            >
                                              <img
                                                alt=""
                                                style={{
                                                  resizeMode: "cover",
                                                  width: "100%",
                                                  height: "100%",
                                                }}
                                                className="playerProfilePic_home_tile"
                                                src={item}
                                              />
                                            </div>
                                          );
                                        })}
                                    </td>
                                  </tr>
                                );
                              }
                            })}

                          <tr>
                            <td>
                              <div className="col-sm-12">
                                <h5 className=" text-sm">Customer Details:</h5>
                              </div>
                            </td>
                            <td>
                              {/* <h5 className=" text-sm">{orderlist.Customer}</h5> */}
                              <h5 className=" text-sm">
                                {customer && customer.Name}
                              </h5>
                              <h5 className=" text-sm">
                                {customer && customer.Phone}
                              </h5>
                              <h5 className=" text-sm">
                                {customer && customer.Email}
                              </h5>
                            </td>
                          </tr>
                          {rider && (
                            <tr>
                              <td>
                                <div className="col-sm-12">
                                  <h5 className=" text-sm">
                                    Deliveryboy Details
                                  </h5>
                                </div>
                              </td>
                              <td>
                                {rider && (
                                  <>
                                    <h5 className=" text-sm">
                                      {rider.riderFirstName}{" "}
                                      {rider.riderLastName}
                                    </h5>
                                    <h5 className=" text-sm">
                                      {rider.riderPhone}
                                    </h5>
                                    <h5 className=" text-sm">
                                      {rider.RiderVehicleType.name}
                                    </h5>
                                  </>
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {polyChords.length !== 0 && bounds.length !== 0 && (
              <MapContainer
                ref={mapRef}
                style={{
                  height: window.innerHeight / 1.9,
                  width: window.innerWidth / 2,
                  marginBottom: "100px",
                }}
                scrollWheelZoom={true}
                bounds={bounds}
                boundsOptions={bounds}
              >
                <Marker
                  icon={
                    orderList?.porterOrder?.VehicleType === "SUV/MUV"
                      ? suvPng
                      : orderList?.porterOrder?.VehicleType === "Sedan"
                      ? sedanPng
                      : orderList?.porterOrder?.VehicleType === "Hatch Back" &&
                        hatchBackPng
                  }
                  position={[polyChords[0][0], polyChords[0][1]]}
                >
                  <Popup>Pickup Location{" "}
                  {`[${[polyChords[0][0], polyChords[0][1]]}]`}
                  </Popup>
                </Marker>
                <Marker
                  icon={myIcon}
                  position={[
                    polyChords[polyChords.length - 1][0],
                    polyChords[polyChords.length - 1][1],
                  ]}
                >
                  <Popup>Drop Location</Popup>
                </Marker>
                <Polyline opacity={30} weight={4} positions={polyChords} />

                <TileLayer
                  url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                  maxZoom={21}
                  minZoom={4}
                  minZoomIsDrawing={18}
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
              </MapContainer>
            )}
          </>
        )}
      </div>
    </div>
  );
}
